module.exports = __webpack_public_path__ + "fonts/TheMix_cls_TT6_.3ee78495.woff";